"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorHandler = exports.onContractError = exports.DefaultErrorHandler = exports.OutOfGasErrorHandler = void 0;
var types_1 = require("./types");
var OutOfGasErrorHandler = (function (_super) {
    __extends(OutOfGasErrorHandler, _super);
    function OutOfGasErrorHandler(handler) {
        return _super.call(this, function (e) { return e.toString().match(/insufficient fee/g); }, handler) || this;
    }
    return OutOfGasErrorHandler;
}(types_1.ErrorHandler));
exports.OutOfGasErrorHandler = OutOfGasErrorHandler;
var DefaultErrorHandler = (function (_super) {
    __extends(DefaultErrorHandler, _super);
    function DefaultErrorHandler(handler) {
        return _super.call(this, function (e) { return true; }, handler) || this;
    }
    return DefaultErrorHandler;
}(types_1.ErrorHandler));
exports.DefaultErrorHandler = DefaultErrorHandler;
var errorHandlers = {};
function onContractError(contract, handler) {
    var contractId = contract.id;
    var currentContracts = Object.keys(errorHandlers);
    if (!currentContracts.includes(contractId)) {
        errorHandlers[contractId] = [];
    }
    var handlers = errorHandlers[contractId];
    var hasHandler = handlers.find(function (it) { return it.constructor.name === handler.constructor.name; });
    if (!hasHandler) {
        errorHandlers[contractId].push(handler);
    }
}
exports.onContractError = onContractError;
function getErrorHandler(id, e) {
    var _a;
    return (_a = errorHandlers[id]) === null || _a === void 0 ? void 0 : _a.find(function (it) { return it.test(e); });
}
exports.getErrorHandler = getErrorHandler;
//# sourceMappingURL=errors.js.map